<div class="search-row">
    <digihaven-search-bar
        class="search-row__search"
        [tag]="advancedSearchTag"
        [enableSavedQueries]="false"
        [enableAdvancedSearch]="enableAdvancedSearch"
        [recordSearch]="recordSearch"
        (queryChanges)="onQueryChange($event)"
    ></digihaven-search-bar>
    <ng-container *ngIf="columnPickerGroups$ | async as columnPickerGroups">
        <ng-container *ngIf="columnPickerGroups.length">
            <dh-column-picker
                class="search-row__columns"
                [groups]="columnPickerGroups"
                (columnSelectionChanged)="onColumnSelectionChanged($event)"
                (showSubfoldersChanged)="onShowSubfoldersChanged($event)"
                (saveColumnSelection)="onColumnsApply()"
                (resetColumnSelection)="onColumnsReset()"
                (discardColumnSelection)="onColumnPickerClosed()"
            ></dh-column-picker>
        </ng-container>
    </ng-container>
    <ng-content></ng-content>
</div>
